<template>
  <v-list-item class="py-12 px-0">
    <v-avatar class="mr-6" color="grey lighten-1" size="128">
      <v-img :src="src" />
    </v-avatar>

    <v-list-item-content>
      <v-list-item-title class="mb-3 title text-uppercase" v-text="name" />
      <base-body :text="blurb" space="3" />

      <div class="mx-n2">
        <a
          v-for="link in links"
          v-bind:key="link.url"
          v-bind:href="link.url"
          target="_blank"
          rel="noopener noreferrer"
          style="text-decoration-line: none;"
        >
          <v-icon class="px-2" small v-text="`mdi-${link.type}`"></v-icon>
        </a>
      </div>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "NewsAuthor",

  props: {
    name: String,
    blurb: String,
    src: String,
    links: Array
  },

  data: () => ({})
};
</script>
